import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

const STORAGE_KEY = "lottonest.theme";

/** An explicit choice beats the OS setting and survives a reload. */
function useTheme() {
  const [theme, setTheme] = useState(() => localStorage.getItem(STORAGE_KEY) || "system");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "system") {
      root.removeAttribute("data-theme");
      localStorage.removeItem(STORAGE_KEY);
    } else {
      root.setAttribute("data-theme", theme);
      localStorage.setItem(STORAGE_KEY, theme);
    }
  }, [theme]);

  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  const isDark = theme === "dark" || (theme === "system" && prefersDark);

  return { isDark, toggle: () => setTheme(isDark ? "light" : "dark") };
}

function Navbar() {
  const { isDark, toggle } = useTheme();

  return (
    <nav className="navbar">
      <div className="navbar-logo">
        <NavLink to="/">LottoNest</NavLink>
      </div>

      <div className="navbar-links">
        <NavLink to="/" end>Home</NavLink>
        <NavLink to="/analytics">Analytics</NavLink>
        <NavLink to="/community">Community</NavLink>
        <NavLink to="/profile">Profile</NavLink>
        <NavLink to="/about">About</NavLink>
        <button
          type="button"
          className="theme-toggle"
          onClick={toggle}
          aria-label={isDark ? "Switch to light theme" : "Switch to dark theme"}
        >
          {isDark ? "☀" : "☾"}
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
